/** PCのFigmaの画像のデザイン = 146px + padding 8px * 2 */
export const PC_MIN_ITEM_WIDTH = 162;
/** SPのFigmaの画像のデザイン = 109px + padding 4px * 2 */
export const SP_MIN_ITEM_WIDTH = 117;
/** パッケージ画像の規定のアスペクト比率 */
export const PACKAGE_ASPECT_RATIO = "7.11/5";
